import { INTERACTION_HANDLER_PREFIX } from "@modules/module/ModuleUtils";
import { busService } from "@modules/bus/BusService";
import { Service } from "@modules/module";
/**
 * This is meant to be extended, not used directly.
 * Classes that extend InteractionHandler must be registered in the InteractionModule.
 * They will then listen to user-input and trigger actions accordingly.
 * Only works in combination with Models that have either a Behavior or an Action(-Parameters).
 */
export class InteractionHandler extends Service {
    /**
     *
     * @param name
     * @param behaviorNames When those behavior are triggered, the InteractionModule will call this interactionHandler.
     * @param actionNames
     * @param speechCommandNames
     */
    constructor(name, behaviorNames, actionNames, speechCommandNames) {
        super(busService.connection(INTERACTION_HANDLER_PREFIX + name));
        this.behaviorNames = behaviorNames;
        this.actionNames = actionNames;
        this.speechCommandNames = speechCommandNames;
    }
    getActionDescription(_actionParameters, _modelUid) {
        return "";
    }
    performAction(_actionParameters, _actionContext) { }
    getBehaviorDescription(_behaviorParameters, _modelUid) {
        return "";
    }
    onSelect(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onDeselect(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    /**
     * @retrun should return true if a Context Menu has been opened
     */
    onOpenContextMenu(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) {
        return false;
    }
    onSelectButtonPress(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onSelectButtonRelease(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onSelectButtonClick(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onSelectButtonDoubleClick(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onSelectButtonHold(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onSelectButtonHoldReleased(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
    onControllerMove(_behaviorParameters, _modelUid, _controllerParameters, _hitPoint // hit point
    ) { }
}
